import React, { useEffect, useMemo, useState } from "react";
import { Modal, Portal, Text } from "react-native-paper";
import { Alert, StyleSheet, TextInput, View } from "react-native";
import DateModule from "./DateModule";
import { TextInputTemp, MyButton, AvartaDropDown, GenderSelect } from "./buttonsAndControls";
import { getFirestore, collection, doc, updateDoc, addDoc, query, where, getDocs, DocumentData, DocumentReference, deleteDoc, getDoc, setDoc } from "firebase/firestore";
import { branch, companyDir } from "./StockAwareTempData";

const darkColour='#2a2d3e'

interface RegData {
  _regID: string;
  _firstname: string;
  _middlename: string;
  _lastname: string;
  _username: string;
  _password: string;
  _avatar: string;
  _phone: string;
  _birthDate: string;
  _gender: string;
  _address: string;
  onClicked: (text: string) => void;
  showModal: boolean;
  isEdit: boolean;
  _salary?: string;
  _newBranch?: boolean
  _branchName?: string;
  _branchAddress?: string;
}
const Registration: React.FC<RegData> = ({_regID, _firstname, _middlename, _lastname, _username, _salary, _newBranch, _branchName, _branchAddress, _avatar, _phone, _birthDate, _gender, _address, isEdit, onClicked, showModal = false,}) => {
  const [firstname, setFirstname] = useState(_firstname)
  const [middlename, setMiddlename] = useState(_middlename)
  const [lastname, setLastname] = useState(_lastname)
  const [phone, setPhone] = useState(_phone)
  const [password, setPassword] = useState('')
  const [retypePassword, setRetypePassword] = useState('')
  const [username, setUsername] = useState('')
  const [salary, setSalary] = useState(_salary);
  const [address, setAddress] = useState(_address)
  const [avarta, setAvarta] = useState( _avatar ?  _avatar :
    _gender === 'Female' ? './src_Files/Avatars/7-faceless-black-lady.png' : './src_Files/Avatars/14-man-laughing.png');
  const whichAvatar = _avatar ?  _avatar.charAt(20) + _avatar.charAt(21) : _gender === 'Female' ? '7-' : '14';
  const [gender, setGender] = useState(_gender)
  const [birthDate, setBirthDate] = useState(_birthDate)
  const [errorFirstname, setErrorFirstname] = useState(false);
  const [firstnameErrorCheck, setfirstnameErrorCheck] = useState('');
  const [errorUsername, setErrorUsername] = useState(false);
  const [usernameErrorCheck, setUsernameErrorCheck] = useState('');
  const [errorLastname, setErrorLastname] = useState(false);
  const [lastnameErrorCheck, setLastnameErrorCheck] = useState('');
  const [errorPhone, setErrorPhone] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);
  const [passwordMatchCheck, setPPasswordMatchCheck] = useState('');
  const [addressError, setAddressError] = useState(false)
  const [genderError, setGenderError] = useState(false)
  const [dateError, setDateError] = useState(false)
  const [phoneOptionalError, setPhoneOptionalError] = useState(false)
  const [passwordOptionalError, setPasswordOptionalError] = useState(false)
  const [rePasswordOptionalError, setRePasswordOptionalError] = useState(false)
  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = today.getFullYear();
  const formattedDate = `${year}-${month}-${day}`;

  const isAlphanumeric = (value: string) => {
    const hasLetter = /[a-zA-Z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    return hasLetter && hasNumber;
  };

  const dataToAdd = {
    firstname: firstname,
    middlename: middlename,
    lastname: lastname,
    phone: phone,
    username: username,
    password: password,
    dob: birthDate,
    gender: gender,
    address: address,
    avarta: avarta,
    company: companyDir,
    branch: _branchName,
    ...(_username ? {} : _newBranch === true ? { regID: '' } : { regID: _regID })
  };

  const employeeDataToAdd = {
    firstname: firstname,
    middlename: middlename,
    appUser: true,
    lastname: lastname,
    phone: phone,
    dob: birthDate,
    gender: gender,
    doe: formattedDate,
    salary: salary,
    address: address,
    company: companyDir,
    branch: _branchName,
  };

  const branchData = {
    branchName: _branchName,
    branchAddress: _branchAddress
  }

  const addToFirestore = async (data: any) => {
    if (_newBranch === true) {
      try {
        await addDoc(collection(getFirestore(), companyDir, _branchName, 'employee'), employeeDataToAdd)
        .then(async (empDoc) => {
          dataToAdd.regID = empDoc.id
          const branchDoc = setDoc(doc(getFirestore(), companyDir, _branchName), branchData);
          await addDoc(collection(getFirestore(), 'users'), dataToAdd);
          console.log("Document updated successfully.");
        })
        
        window.confirm(`${_firstname} ${_lastname} has successfully been added to app users.`);
      } catch (error) {
        window.confirm(`Failed to add to app users. ${error}`);
      }
    } else {
      try {
        await addDoc(collection(getFirestore(), "users"), data);
        const docRef = doc(getFirestore(), companyDir, branch, 'employee', _regID);
        const docSnapshot = await getDoc(docRef);
        if (docSnapshot) {
          await updateDoc(docRef, {appUser: true});
        }
        window.confirm(`${_firstname} ${_lastname} has successfully been added to app users.`);
      } catch (error) {
        window.confirm(`Failed to add to app users.`);
      }
    }
  };

  const updateFirestore = async (data: any, docRef: DocumentReference<DocumentData, DocumentData>) => {
    try {
      await updateDoc(docRef, data);
      window.confirm(`${_firstname} ${_lastname}'s data has been updated successfully.`);
    } catch (error) {
      window.confirm(`Failed to update this app user. ${error}`);
      console.error("Error updating document: ", error);
    }
  }
      
  const handleRegistration = async () => {
    const dateParts = birthDate.split('-');
    const day = dateParts[0].trim()
    const month = dateParts[1].trim()
    const year = dateParts[2].trim()

    firstname.trim() === '' 
    ? (setfirstnameErrorCheck('Firstname is required'), setErrorFirstname(true))
    : (setfirstnameErrorCheck(''), setErrorFirstname(false));

    lastname.trim() === '' 
    ? (setLastnameErrorCheck('Lastname is required'), setErrorLastname(true))
    : (setLastnameErrorCheck(''), setErrorLastname(false));

    username.trim() === '' 
    ? (setUsernameErrorCheck('Username is required'), setErrorUsername(true))
    : (setUsernameErrorCheck(''), setErrorUsername(false));

    address.trim() === '' ? (setAddressError(true)) : setAddressError(false);

    gender?.trim() === '' ? setGenderError(true) : setGenderError(false);

    (day === '' || month === '' || year === '' || birthDate === formattedDate) ?
    setDateError(true) : setDateError(false);

    ((!isAlphanumeric(password)) || password.length < 8) ?
    setPasswordOptionalError(true) : setPasswordOptionalError(false);

    retypePassword !== password ? setRePasswordOptionalError(true) : setRePasswordOptionalError(false)

    phone.trim() === '' ? setPhoneOptionalError(true) : setPhoneOptionalError(false)

    if (firstname.trim() === '' || lastname.trim() === '' || username.trim() === '' || retypePassword !== password ||
    ((!isAlphanumeric(password)) || password.length < 8) || address.trim() === '' || phone.trim() === '' || 
    avarta.trim() === '' || gender.trim() === '' || (day === '' || month === '' || year === '' || birthDate === formattedDate)) {
    window.confirm(`You have not met the minimum user registration requirements, please check the missing parts.`);
    } else {
      try {
        const myCollection = collection(getFirestore(), 'users');
        const q = query(myCollection, where('regID', '!=', ''), where('regID', '==', _regID));
        const querySnapshot = await getDocs(q);
        if (querySnapshot.size > 0) {
          const docRef = querySnapshot.docs[0].ref;
          updateFirestore(dataToAdd, docRef);
        } else {
          addToFirestore(dataToAdd);
        }
      } catch (error) {
      }
      setShowUserValue(true);
      onClicked('Yes');
    };

  };

  const handleFirstname = (text: string) => {
    setFirstname(text)
  }

  const firstnameFocus = () => {
    setfirstnameErrorCheck('')
    setErrorFirstname(false)
  }

  const handleMiddlename = (text:string) => {
    _middlename = text;
    console.log(text)
  }

  const handleLastname = (text:string) => {
    setLastname(text)
  }

  const lastnameFocus = () => {
    setLastnameErrorCheck('')
    setErrorLastname(false)
  }

  const handlePhone = (text:string) => {
    const digitsOnly = text.replace(/[^0-9]/g, '');
    setPhone(digitsOnly)
  }

  const usernameFocus = () => {
    setUsernameErrorCheck('')
    setErrorUsername(false)
  }

  const handlePassword = (text:string) => {
    setShowPassValue(false);
    setPassword(text)
  }

  const handleRetypePassword = (text:string) => {
    setRetypePassword(text)
    setPPasswordMatchCheck(password)
  }

  const [showUserValue, setShowUserValue] = useState(true)
  const [showPassValue, setShowPassValue] = useState(true)

  const [showU, setShowU] = useState(true)
  const [tex, setTex] = useState(_username)

  const handleUsername = (text:string) => {
    setShowUserValue(false);
    setUsername(text);      
  }

  const handleUsernameOnChange = (text:string) => {
    setShowUserValue(false);

  }

  const handleAddress = (text:string) => {
    setAddress(text)
  }

  const handleAvatar = (avartaString: string) => {
    setAvarta(avartaString)
  }

  const handleGender = (text:string) => {
    setGender(text)
  }

  const handleBirthDate = (day: string, month: string, year: string) => {
    setBirthDate(year + '-' + month + '-' + day)
  }

  const resetDateError = () => {
    setDateError(false)
  }

  const deleteItem = () => {
    const dialogResult = window.confirm(`App User Deletion.\nAre you sure to delete ${firstname} ${lastname} from app users?`);
      if (dialogResult === true) {
        handleUserDeletion()
      }
  };

  const handleUserDeletion = async () => {
    try {
      const myCollection = collection(getFirestore(), 'users');
      const q = query(myCollection, where('regID', '==', _regID));
      const querySnapshot = await getDocs(q);
      if (querySnapshot.size > 0) {
        const docRef = querySnapshot.docs[0].ref;
        deleteDoc(docRef);
        const eDocRef = doc(getFirestore(), companyDir, branch, 'employee', _regID);
        const docSnapshot = await getDoc(eDocRef);
        if (docSnapshot) {
          await updateDoc(eDocRef, {appUser: false});
        }
        window.confirm(`App user deletion is successful.`);
      }
    } catch (error) {
      window.confirm(`Failed to delete this app user.`);
      console.error("Error deleting document: ", error);
    }
    setShowUserValue(true);
    onClicked('Yes');
  }

  return (
    <Portal>
      <Modal visible={showModal} onDismiss={() => showModal} dismissable={false} contentContainerStyle={styles.modalContainer}>
      <View style={{backgroundColor:'transparent', flex:1, alignItems:'center'}}>
        <View style={styles.regBox}>
            <Text style={styles.headerText}>
                Admin Registration
            </Text>
            
            <TextInputTemp lTxt='Firstname' plhrTxt='Enter Firstname' value={_firstname} errorMessage={firstnameErrorCheck} 
            showErrorName = {errorFirstname} focusReceived={firstnameFocus} onChangeText={(value)=> setFirstname(value)} editable = {isEdit} />

            <TextInputTemp lTxt='Middlename' plhrTxt='Enter Middlename' value= {_middlename} editable = {isEdit}/>

            <TextInputTemp lTxt='Lastname' plhrTxt='Enter Lastname' value= {_lastname} editable = {isEdit}
            errorMessage={lastnameErrorCheck} showErrorName = {errorLastname} focusReceived={lastnameFocus}/>

            <TextInputTemp lTxt='Phone' plhrTxt='Enter Phone Number' optionalError={phoneOptionalError} value= {_phone} editable = {isEdit}
            errorMessage='Phone number may be incorrect' showError = {errorPhone} focusReceived={()=> setPhoneOptionalError(false)} />

            <TextInputTemp lTxt='Username' plhrTxt='Enter desired username' errorMessage={usernameErrorCheck} 
             defaultValue= {_username}//{...(showUserValue === true ? { value: _username } : {})} 
             showErrorName = {errorUsername} onChange={handleUsername} focusReceived={usernameFocus}/>

            <TextInputTemp lTxt='Password' plhrTxt='Enter Password' optionalError={passwordOptionalError}
            scTxt={true} errorMessage="Password must be at least 8 characters, and alphanumeric"
            showError={errorPassword} focusReceived={()=> setPasswordOptionalError(false)} onChangeText={handlePassword}/>
            
            <TextInputTemp lTxt='Retype Password' plhrTxt='Enter Password again' optionalError={rePasswordOptionalError}
            scTxt={true} errorMessage="Password mismatch" focusReceived={()=> setRePasswordOptionalError(false)}
            showError={errorPassword} passwordToCompare={passwordMatchCheck} onChangeText={handleRetypePassword}/>

            <View style={{flexDirection:'row', alignSelf: 'center',  marginTop:10 }}>
              <View style={{...styles.addressTextContainer, borderColor: addressError ? '#C40C0C' : darkColour}}>
                <Text style={{...styles.addressLabel, color: addressError ? '#C40C0C' : 'white'}}>
                    Address
                </Text>
              </View>
              <View style={{...styles.addressBox, padding: 0, flexDirection:'column', borderColor: addressError ? '#C40C0C' : 'black'}}>
                <TextInput
                  style={{...styles.addressBox, marginBottom:0, borderWidth:0 }}
                  placeholder='Enter house address'
                  multiline
                  numberOfLines={4}
                  spellCheck= {false}
                  value={_address}
                  editable = {isEdit}
                  onFocus={()=> setAddressError(false)}
                />
              {addressError === true  &&  (
                <Text style={{ color: '#C40C0C', marginTop: -15, marginLeft:10, fontSize:12 }}>You have not entered an address</Text>
              )}
              </View>
            </View>

            <View style={{width:500, flexDirection:'column', alignSelf:'center', marginTop:10}}>
              <View style={{flexDirection:'row', width:500, alignSelf:'center', }}>
                
                <View style={styles.avatarContainer}>
                  <Text style={styles.avatarText}>
                    Pick an Avatar
                  </Text>
                </View>
            
              <View style={{width:100, backgroundColor:'white'}}>
                <View style={{flexDirection:'row', alignSelf:'flex-start', marginLeft:-20, marginTop:-15}}>
                  <AvartaDropDown onImageSelected={handleAvatar} 
                    source={
                      whichAvatar === '1-' ? require('./src_Files/Avatars/1-black-shade-girl.png')
                    : whichAvatar === '2-' ? require('./src_Files/Avatars/2-blue-eyes-male.png')
                    : whichAvatar === '3-' ? require('./src_Files/Avatars/3-boy-on-hood.png')
                    : whichAvatar === '4-' ? require('./src_Files/Avatars/4-eye-glass-male.png')
                    : whichAvatar === '5-' ? require('./src_Files/Avatars/5-faceless-black-girl.png')
                    : whichAvatar === '6-' ? require('./src_Files/Avatars/6-faceless-black-hair.png')
                    : whichAvatar === '7-' ? require('./src_Files/Avatars/7-faceless-black-lady.png')
                    : whichAvatar === '8-' ? require('./src_Files/Avatars/8-faceless-female.gif')
                    : whichAvatar === '9-' ? require('./src_Files/Avatars/9-faceless-girl.png')
                    : whichAvatar === '10' ? require('./src_Files/Avatars/10-faceless-g-laughing.png')
                    : whichAvatar === '11' ? require('./src_Files/Avatars/11-faceless-lady.png')
                    : whichAvatar === '12' ? require('./src_Files/Avatars/12-faceless-male.gif')
                    : whichAvatar === '13' ? require('./src_Files/Avatars/13-fam-guy-Brian.png')
                    : whichAvatar === '14' ? require('./src_Files/Avatars/14-man-laughing.png')
                    : whichAvatar === '15' ? require('./src_Files/Avatars/15-office-man.png')
                    : whichAvatar === '16' ? require('./src_Files/Avatars/16-young-boy.png')
                    : whichAvatar === '17' ? require('./src_Files/Avatars/17-young-girl.png')
                    : whichAvatar === '18' ? require('./src_Files/Avatars/18-young-white-boy.png')
                    : require('./src_Files/Avatars/14-man-laughing.png')
                    }
                  />
                </View>
              </View>
              <GenderSelect onError={genderError} pressed={()=> setGenderError(false)} 
                disabled = {!isEdit} gender= {_gender} onGenderSelected={handleGender}
              />
              </View>
              <View style={{ flexDirection:'row', marginTop:20}}>
                <View style={{...styles.dateTextContainer, borderColor: dateError ? '#C40C0C' : darkColour}}>
                  <Text style={{...styles.birthDateText, color: dateError? '#C40C0C' : 'white'}}>Birth Date</Text>
                </View>
                <DateModule appearUp = {true} 
                  onError = {dateError} 
                  pressed = {resetDateError} 
                  dateReset = {isEdit} 
                  onNewDateSelected = {handleBirthDate}
                  _day= {_birthDate ? _birthDate.split('-')[2] : undefined} 
                  _month= {_birthDate ? _birthDate.split('-')[1] : undefined} 
                  _year= {_birthDate ? _birthDate.split('-')[0] : undefined}
                />
              </View>

              {_username ?
                <View style={{flexDirection:'row', width:500, alignSelf:'center', marginTop:15, justifyContent: 'space-between'}}>
                  <View>
                      <MyButton btnText= {'Delete'} btnWidth={150} btnTxtClr='white' hndClicked={() =>deleteItem()} />
                  </View>
                  <View>
                    <MyButton btnText='Cancel' btnColor= 'white' btnTxtClr= {darkColour} btnBorWdt={2} 
                      btnPadding={8} btnWidth={150} hndClicked={()=>{setShowUserValue(true); onClicked('')}} 
                    />
                  </View>
                  <View>
                      <MyButton btnText= {'Update'} btnWidth={150} btnTxtClr='white' hndClicked={handleRegistration} />
                  </View>
                </View>
                :
                <View style={{flexDirection:'row', width:500, alignSelf:'center', marginTop:15}}>
                  <View style={{alignSelf:'flex-start'}}>
                    <MyButton btnText='Cancel' btnColor= 'white' btnTxtClr= {darkColour} btnBorWdt={2} 
                      btnPadding={8} hndClicked={()=>{setShowUserValue(true); onClicked('')}} 
                    />
                  </View>
                  
                  <View style={{flexDirection:'column', width:300}}>
                    <View style={{alignSelf:'flex-end'}}>
                      <MyButton btnText= {'Register'} btnTxtClr='white' hndClicked={handleRegistration} />
                    </View>
                  </View>
                </View>
              }
              
              
            </View>
          </View>
        </View>
      </Modal>
    </Portal>
  )
};

const styles = StyleSheet.create ({
  regBox: {
    borderWidth:3, 
    borderRadius:10, 
    borderStyle:'solid', 
    borderColor:darkColour, 
    width:800, 
    height: 750, 
    marginLeft:0,
    backgroundColor:'white'
  },
  headerText: {
    alignSelf:'center', 
    fontFamily:'century gothic', 
    fontSize:17, 
    fontWeight:'bold', 
    textAlign:'center',
    color: darkColour, 
    marginTop:10, 
    marginBottom:0
  },
  addressLabel: {
    color: 'white', 
    fontFamily:'century gothic', 
    fontSize:16, 
    padding:10, paddingHorizontal:5, 
    fontWeight:'normal', 
    alignSelf:'center',
    verticalAlign:'middle'
  },
  addressBox: {
    borderWidth: 1,
    borderRadius:10,
    borderTopLeftRadius:0,
    borderColor: darkColour,
    width:350,
    height:100,
    padding:10,
    color:'black', 
    fontFamily:'century gothic', 
    fontSize:16, 
    fontWeight:'300',
    marginBottom:10,
    marginHorizontal:0,
    alignSelf:'center'
  },
  addressTextContainer: {
    width:150, 
    height: 40, 
    borderTopLeftRadius:10, 
    borderBottomLeftRadius:10, 
    backgroundColor:darkColour, 
    borderWidth:1, 
    borderRightWidth:0
  },
  avatarContainer: {
    width:200, 
    height: 40, 
    backgroundColor:'#2a2d3e', 
    borderTopRightRadius: 0, 
    borderBottomRightRadius:0, 
    borderRadius:10, 
    alignSelf:'center', 
    borderWidth: 1
  },
  avatarText: {
    color:'white', 
    fontFamily:'century gothic', 
    fontSize:16, 
    padding:10, 
    fontWeight:'normal', 
    alignSelf:'center', 
    verticalAlign:'middle'
  },
  birthDateText: {
    fontFamily:'century gothic', 
    color: 'white', 
    fontSize:16, 
    padding:10, 
    paddingLeft:10, 
    fontWeight:'normal'
  },
  dateTextContainer: {
    backgroundColor: darkColour, 
    width:110, 
    height:40,
    borderRadius: 10, 
    borderTopRightRadius:0,
    borderBottomRightRadius:0,
    borderWidth:1,
    borderRightWidth:0,
    borderColor: darkColour,
    marginRight: -25
  },
  modalContainer: {
		justifyContent: 'center',
		alignItems: 'center',
    alignSelf:'center',
		backgroundColor: 'white',
		width:800, 
		height:750, 
		borderWidth:1, 
		borderColor:darkColour, 
		borderRadius:10, 
  }
})

export default Registration